export default __webpack_public_path__ + "static/media/twitter-logo.bff6beee.png";